import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';
import Aria from 'formvalidation/es6/plugins/Aria';
import 'es6-shim';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    [].forEach.call(document.querySelectorAll('main .form-group input'), (inputElement) => {
        inputElement.addEventListener('input', function onInput(e) {
            if (this.value !== '') {
                this.classList.add('not-empty');
            } else {
                this.classList.remove('not-empty');
            }
        });
        if (inputElement.value !== '') {
            inputElement.classList.add('not-empty');
        } else {
            inputElement.classList.remove('not-empty');
        }
    });

    [].forEach.call(document.querySelectorAll('main form'), (formElement) => {
        // form validation
        const plugins = {
            aria: new Aria(),
            trigger: new Trigger({
                event: 'blur',
            }),
            bootstrap3: new Bootstrap3(),
            defaultSubmit: new DefaultSubmit(),
            submitButton: new SubmitButton(),
            declarative: new Declarative({
                html5Input: true,
            }),
        };

        if (document.getElementById('captchaContainer')) {
            plugins.recaptcha = new Recaptcha({
                element: 'captchaContainer',
                siteKey: '6LdXyp0UAAAAABMqylYVIyo4xxeV-tDkoXh8rNFg',
                message: JSON.parse(document.querySelector('#json_translations').innerHTML).reCaptchaErrorMessage,
                size: 'invisible',
            });
        }

        const fv = formValidation(formElement, {
            plugins,
        });

        [].forEach.call(formElement.querySelectorAll('input'), (inputElement) => {
            inputElement.addEventListener('focus', (e) => {
                fv.resetField(e.target.name);
            });
        });
        [].forEach.call(formElement.querySelectorAll('input'), (inputElement) => {
            inputElement.addEventListener('change', (e) => {
                if (e.target.parentElement.querySelector('.server-side-error')) {
                    e.target.parentElement.removeChild(e.target.parentElement.querySelector('.server-side-error'));
                }
            });
        });
    });

    const passwordTests = {
        testLength() {
            return /^.{8,32}/.test(this.value);
        },
        testAlphaNum() {
            return /^(?=.*[a-zA-Z])(?=.*[0-9])/.test(this.value);
        },
        testLowerUpper() {
            return /.*(?=.*[a-z])(?=.*[A-Z]).*/.test(this.value);
        },
        testSpecials() {
            return /.*[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._].*/.test(this.value);
        },
    };

    if (document.querySelector('#full_form_section')) {
        document.querySelector('#full_form_section [type=password]').addEventListener('input', function onInput() {
            const inputElement = this;
            Object.keys(passwordTests).forEach((testName) => {
                const testResult = passwordTests[testName].bind(inputElement)();
                if (testResult !== true) {
                    document.querySelector('#full_form_section .password-tips').querySelector(`.${testName}`).classList.remove('is-valid');
                } else {
                    document.querySelector('#full_form_section .password-tips').querySelector(`.${testName}`).classList.add('is-valid');
                }
            });
        });
        document.querySelector('#full_form_section [type=password]').addEventListener('focus', () => {
            if (!window.matchMedia('(min-width: 980px)').matches) {
                setTimeout(() => {
                    document.querySelector('.password-tips').scrollIntoView({ block: 'center', behavior: 'smooth' });
                }, 100);
            }
        });
    }

    window.ga = window.ga || function initGA(...args) {
        (window.ga.q = window.ga.q || []).push(args);
    };
    window.ga.l = +new Date();
    window.ga(() => {
        setTimeout(() => {
            document.querySelector('[name="startFreeTrial[gaClientId]"]').value = window.ga.getAll()[0].get('clientId');
        }, 1000);
    });
}));
